function togglePassType() {
  let button = $('.profile__icon-eye');
  button.on('click', function() {
    if ($(this).prev().hasClass('active')) {
      $(this).prev().removeClass('active')
      $(this).prev().attr('type', 'password');
    } else {
      $(this).prev().addClass('active')
      $(this).prev().attr('type', 'text');
    }
  });
}
togglePassType();